export const SIZE_MAP: Record<string, string[]> = {
    XS: ['42', '44'],
    S: ['46', '48'],
    M: ['50', '52'],
    L: ['54'],
    XL: ['56', '58'],

    '2XL': ['60', '62'],
    '3XL': ['64', '66'],
    '4XL': ['68', '70'],

    XXL: ['60', '62'],
    XXXL: ['64', '66'],
    XXXXL: ['68', '70'],
     xs: ['42', '44'],
    s: ['46', '48'],
    m: ['50', '52'],
    l: ['54'],
    xl: ['56', '58'],

    '2xl': ['60', '62'],
    '3xl': ['64', '66'],
    '4xl': ['68', '70'],

    xxl: ['60', '62'],
    xxxl: ['64', '66'],
    xxxxl: ['68', '70'],
}

export const normalizeSizes = (sizes?: (string | null)[]) => {
    if (!sizes) return []

    return Array.from(
        new Set(
            sizes.flatMap((size) => {
                if (!size) return []

                const raw = size.trim().toUpperCase()

                // 👉 сначала проверяем карту
                if (SIZE_MAP[raw]) {
                    return SIZE_MAP[raw]
                }

                // 👉 потом вытаскиваем ВСЕ числа
                const numbers = raw.match(/\d+/g)
                if (numbers) {
                    return numbers
                }

                return []
            }),
        ),
    ).sort((a, b) => Number(a) - Number(b))
}